import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import TitlePages from "../../layout/TitlePages";
import Breadcrumbs from "../../layout/Breadcrumbs";

const ImageLink = ({ to, src, alt, text }) => (
  <div>
    <Link to={to}>
      <img src={src} className="img-fluid" alt={alt} />
    </Link>
    <p className="text-strong">{text}</p>
  </div>
);

const Acuerdos = () => {
  useEffect(() => {
    document.title = `Acuerdos Poder Judicial`;
  }, []);

  return (
    <>
      <Breadcrumbs path={[{ label: "Acuerdos Demarcaciones" }]} />
      <TitlePages title="Acuerdos Poder Judicial" subTitle="" />
      <div className="w-100 Grid__folder margin-bottom-2">
        <ImageLink
          to="/DistritacionPJ2025"
          src="https://itetlax.org.mx/assets/img/imgDemA/2025.png"
          alt="Distritación Judicial 2025"
          text="Distritación Judicial 2025"
        />
      </div>
    </>
  );
};

export default Acuerdos;
